<template>
  <div class="balance-indicator">
    <a
      :href="link"
      :title="label"
      class="label label-white f-16"
      data-toggle="tooltip"
      data-placement="bottom"
    >
      <slot />
    </a>
  </div>
</template>

<script>
export default {
  name: 'BalanceIndicator',

  props: {
    link: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'resources/sass/frontend/_color-variables.scss';

.balance-indicator {
  color: $indigo-500;
  a.label {
    border-radius: 4px;
    color: $indigo-500;
    padding: 6px 12px;
    background: #f6f6f6;
    &:hover {
      color: $indigo-500;
      background: #f0f0f0;
    }
  }
}
</style>
